import { Component } from "react";
import http from "../http-common";

// ─────────────────────────────────────────────
//  WorkshopGrid
//
//  Fetches from /api/workshop-items/ and renders
//  a responsive 3-column grid of workshop cards.
//
//  Each card shows:
//    - Square image
//    - Category tag + date row
//    - Title
//    - Short description
//    - Register Now button
// ─────────────────────────────────────────────

class WorkshopGrid extends Component {
  state = {
    workshops: [],
    loading: true,
  };

  componentDidMount() {
    http
      .get("/workshop-items/")
      .then((res) => {
        const data = res.data;
        if (data.success) {
          this.setState({ workshops: data.workshops, loading: false });
        } else {
          console.error("API error:", data.message);
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        console.error("Failed to fetch workshop items:", err);
        this.setState({ loading: false });
      });
  }

  render() {
    const { workshops, loading } = this.state;
    const { onRegister } = this.props;

    return (
      <section className="py-5 bg-white">
        <div className="container py-lg-4" style={{ maxWidth: "1100px" }}>
          {/* Section heading */}
          <h2
            className="display-6 fw-medium text-dark mb-5"
            style={{ letterSpacing: "-0.5px" }}
          >
            Discover the XLP Workshop Series
          </h2>

          {/* Loading state */}
          {loading && (
            <div className="text-center py-5">
              <p className="text-secondary">Cooking up workshops...</p>
            </div>
          )}

          {/* Empty state */}
          {!loading && workshops.length === 0 && (
            <div className="text-center py-5">
              <p className="text-secondary">
                No workshops available at the moment.
              </p>
            </div>
          )}

          {/* Grid */}
          {!loading && workshops.length > 0 && (
            <div className="row g-4 justify-content-start">
              {workshops.map((w) => (
                <div className="col-12 col-md-6 col-lg-4" key={w.id}>
                  <WorkshopGridCard workshop={w} onRegister={onRegister} />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    );
  }
}

// ─────────────────────────────────────────────
//  WorkshopGridCard
// ─────────────────────────────────────────────

function WorkshopGridCard({ workshop, onRegister }) {
  return (
    <div className="d-flex flex-column h-100">
      {/* Square image */}
      <div
        style={{
          width: "100%",
          aspectRatio: "4 / 3",
          overflow: "hidden",
          borderRadius: "8px",
          marginBottom: "16px",
          background: "#f0f0f0",
        }}
      >
        {workshop.image ? (
          <img
            src={workshop.image}
            alt={workshop.title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        ) : (
          <div
            className="d-flex align-items-center justify-content-center h-100"
            style={{ background: "#f0f0f0" }}
          >
            <span className="text-secondary" style={{ fontSize: "13px" }}>
              No image here
            </span>
          </div>
        )}
      </div>

      {/* Category + Date row */}
      <div
        className="d-flex align-items-center gap-2 mb-3"
        style={{ fontSize: "12px" }}
      >
        {/* Category tag */}
        <span
          className="fw-medium text-uppercase"
          style={{
            color: "#b54a2e",
            backgroundColor: "#b5492e0f",
            letterSpacing: "0.5px",
            whiteSpace: "nowrap",
          }}
        >
          {workshop.category}
        </span>

        {/* Horizontal line between category and date */}
        <div
          style={{
            flex: 1,
            height: "1px",
            background: "#dee2e6",
          }}
        />

        {/* Date */}
        {workshop.workshop_date && (
          <span
            className="text-secondary text-uppercase fw-medium"
            style={{ whiteSpace: "nowrap", letterSpacing: "0.3px" }}
          >
            {workshop.workshop_date}
          </span>
        )}
      </div>

      {/* Title */}
      <h3
        className="h5 fw-medium text-medium mb-2"
        style={{ lineHeight: "1.3" }}
      >
        {workshop.title}
      </h3>

      {/* Description */}
      <p
        className="text-secondary mb-4"
        style={{ fontSize: "14px", lineHeight: "1.6", flexGrow: 1 }}
      >
        {workshop.description}
      </p>

      {/* Register Now button */}
      <div>
        <button
          onClick={() => onRegister(workshop.title)}
          className="btn btn-brand px-4 py-2 d-inline-flex align-items-center gap-2"
        >
          {workshop.button_text}
        </button>
      </div>
    </div>
  );
}

export default WorkshopGrid;
